import { render } from "./FrmGenerateDumpDiscardsPallet.vue?vue&type=template&id=f54c0ce8&scoped=true"
import script from "./FrmGenerateDumpDiscardsPallet.vue?vue&type=script&lang=js"
export * from "./FrmGenerateDumpDiscardsPallet.vue?vue&type=script&lang=js"

import "./FrmGenerateDumpDiscardsPallet.vue?vue&type=style&index=0&id=f54c0ce8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f54c0ce8"]])

export default __exports__